import React from 'react';

// components
import TicketUpdateOnTheWay from './TicketUpdateOnTheWay';
import TicketUpdateDelayed from './TicketUpdateDelayed';
import ticketActions from '../../constants/ticketActions';
import TicketUpdateDelivered from './TicketUpdateDelivered';
import TicketUpdatePickup from './TicketUpdatePickup';

export const TicketUpdate = ({ ticket, type, ok, cancel }) => {
  if (type === ticketActions.DELAYED) {
    return <TicketUpdateDelayed ticket={ticket} type={type} ok={ok} cancel={cancel} />;
  }
  if (type === ticketActions.ON_THE_WAY) {
    return <TicketUpdateOnTheWay ticket={ticket} type={type} ok={ok} cancel={cancel} />;
  }
  if (type === ticketActions.DELIVERED) {
    return <TicketUpdateDelivered ticket={ticket} type={type} ok={ok} cancel={cancel} />;
  }
  if (type === ticketActions.PICKUP) {
    return <TicketUpdatePickup ticket={ticket} type={type} ok={ok} cancel={cancel} />;
  }
  return <></>;
};

export default TicketUpdate;
